import React, { useReducer, useEffect } from 'react';
import postData from './postData';

const useFilter = (postUrl, defaultFilter, submit) => {
    const initialState = {
        isLoaded: false,
        items: [],
        filter: defaultFilter || {},
        pageInfo: {
            pageNumber: 0,
            pageSize: 0,
            totalItems: 0,
            pageCount: 0,
            itemsFrom: 0,
            itemsTo: 0,
            isFirstPage: true,
            isLastPage: true
        },
        canCreate: false,
        url: postUrl
    };


    const [state, dispatch] = useReducer((currentState, action) => {
        switch (action.type) {
            case 'loaded':
                return {
                    ...currentState,
                    items: action.payload.items,
                    isLoaded: true,
                    pageInfo: action.payload.pageInfo,
                    canCreate: action.payload.canCreate
                };
            case 'loading':
                return { ...currentState, isLoaded: false };
            case 'setData':
                return { ...currentState, items: action.payload, isLoaded: true }
            case 'setFilter':
                return { ...currentState, filter: action.payload };
            case 'setUrl':
                //if updating url, we assume all filters will get reset
                return { ...initialState, url: action.payload };
            default:
                return currentState;
        }
    }, initialState);

    //a local variable that can be updated and used at runtime for synchronous operations
    //like updating the filter and submitting the filter without waiting on the async state to render
    const filter = { ...state.filter };

    useEffect(() => {
        if (submit) {
            submitFilter();
        }
    }, []);

    function setFilter(eventOrValues) {
        //allow arrays so multiple values can be manually set
        if (Array.isArray(eventOrValues)) {
            for (let i = 0; i < eventOrValues.length; i++) {
                filter[eventOrValues[i].name] = eventOrValues[i].value;
            }
        } else {
            const { target: { name, type, value, checked } } = eventOrValues;

            if (name.indexOf('.') > 1) {
                const [objName, propName] = name.split('.');
                if (type === 'checkbox') {
                    filter[objName][propName] = checked;
                } else if (type === 'number') {
                    filter[objName][propName] = parseFloat(value);
                } else {
                    filter[objName][propName] = value;
                }
            } else {
                if (type === 'checkbox') {
                    filter[name] = checked;
                } else if (type === 'number') {
                    filter[name] = parseFloat(value);
                } else {
                    filter[name] = value;
                }
            }


        }
        dispatch({ type: 'setFilter', payload: filter });
    }

    function setPage(page) {
        filter.pageNumber = page;
        postData(state.url, filter, updateData);
    }

    function setSort(col) {
        if (filter.sortColumn === col) {
            filter.sortDesc = !filter.sortDesc;
        } else {
            filter.sortColumn = col;
        }
        dispatch({ type: 'setFilter', payload: filter });
        postData(state.url, filter, updateData);
    }

    function setUrl(newUrl) {
        dispatch({ type: 'setUrl', payload: newUrl });
    }

    function submitFilter() {
        dispatch({ type: 'loading' });
        postData(state.url, filter, updateData);
    }

    function setData(data) {
        dispatch({ type: 'setData', payload: data });
    }

    function updateData(data) {
        dispatch({ type: 'loaded', payload: data });
    }

    return {
        items: state.items,
        filter: { ...state.filter },
        isLoaded: state.isLoaded,
        pageInfo: {
            ...state.pageInfo,
            setPage: setPage,
            setSort: setSort
        },
        canCreate: state.canCreate,
        setData: setData,
        setFilter: setFilter,
        setUrl: setUrl,
        submitFilter: submitFilter
    }
}

export default useFilter;